<template>
<div>
  <div class="row">
    <div class="col-12 col-md-6 mb-3 bg-dark border-radius p-2">
      <div v-if="files && files.length >= exportLimit">
        You can only export {{ exportLimit }} zip files. Please delete a package and then try again.
      </div>
      <zip-exporter
          v-else-if="!$store.getters.isSuperAdmin"
          :organization-id="organizationId"
      />
      <div v-else>
        SFX user cannot do exports, use another user pls
      </div>
    </div>
    <div class="col-12 col-md-6 mb-3">
      <div v-if="$store.getters.isSuperAdmin">
        <drop-down
            v-if="assets.length > 0"
            class="mb-2"
            :values="assets.map(item => {return item.id})"
            :labels="assets.map(item => {return item.user ? item.user : item.externalId})"
            @select="(value) => {assetId = value; loadFiles()}"
        />
        <div v-else>
          No exports available
        </div>
      </div>

      <div @click="loadZipsForOrg" class="settings-button d-inline-block mb-2">Reload <div class="turn-icon d-inline-block"><icon type="robot" /></div></div>
      <zip-export
          :key="file.key"
          v-for="file in sortedFiles"
          :file-meta="file"
          :asset-id="assetId"
          @reload="loadZipsForOrg"
      />
    </div>
   <div v-html="queuePage" />
  </div>
</div>
</template>

<script>
import ZipExport from "./ZipExport";
import ZipExporter from "@/components/exporter/ZipExporter.vue";
import Icon from "@/components/Icon";
import DropDown from "@/components/forms/DropDown.vue";
import dateMixinJs from "@/components/mixins/DateMixin.js.vue";

export default {
  name: "ZipExportList",
  components: {
    ZipExport,
    ZipExporter,
    Icon,
    DropDown
  },
  mixins: [dateMixinJs],
  props: {
    organizationId: {type: String, required: true},
  },
  data() {
    return {
      files: [],
      assets: [],
      assetId: "",
      queuePage: null,
      userNames: [],
      exportLimit: 10
    }
  },
  computed: {
    sortedFiles() {
      let separatedFiles = JSON.parse(JSON.stringify(this.files));
      return separatedFiles && separatedFiles.length ? separatedFiles.sort((a, b) => {
        return this.unixFromISO(b.lastModified) - this.unixFromISO(a.lastModified);
      }) : []
    }
  },
  watch: {
    organizationId() {
      this.loadZipsForOrg();
      this.getQueue();
    }
  },
  beforeMount() {
    this.init();
  },
  methods: {
    init() {
      this.loadZipsForOrg();
      this.getQueue();
    },
    async getQueue() {
      this.queuePage = await this.$store.dispatch('clientGetExportQueue');
    },
    async loadAssets(filter) {
      await this.$store.dispatch('clientLoadAssets', {
        filter
      }).then(async assets => {
        this.assets = assets;
        if(this.$store.getters.isSuperAdmin && this.assets.length > 0) {
          let filter = this.assets.length === 1 ? 'id eq ' + this.assets[0].externalId : "id in '" + this.assets.map(item => {return item.externalId}).join("' '");
          this.users = await this.$store.dispatch('loadUsers', {
            filter
          })
          this.assets.map(item => {
            const user = this.users.find(user => user.id === item.externalId);
            item.user = user.name;
          })
        }
        if(!assets || !assets.length) {
          console.log('No export asset found')
          this.files = [];
          return;
        }
        this.assetId = assets[0].id;
        return this.loadFiles();
      })
    },
    async loadFiles() {
      await this.$store.dispatch('loadAssetFiles', {
        id: this.assetId,
      }).then(files => {
        this.files = files;
      })
    },
    async loadZipsForOrg() {
      if(!this.organizationId) {
        throw new Error('organizationId is missing')
      }
      if(this.$store.getters.isSuperAdmin) {
        await this.loadAssets('type eq export,organizationId eq ' + this.organizationId);
      } else {
        await this.loadAssets('type eq export,organizationId eq ' + this.organizationId +',externalId eq ' + this.$store.getters.getCurrentUserId);
      }
    }
  }
}
</script>

<style scoped lang="scss">
.settings-button {
  .turn-icon {
    transition: all 300ms ease;
  }
  &:hover {
    .turn-icon {
      transform: rotate(90deg);
    }
  }
}
</style>